import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subbase-coverage-calculator',
  templateUrl: './subbase-coverage-calculator.component.html',
  styleUrls: ['./subbase-coverage-calculator.component.scss']
})
export class SubbaseCoverageCalculatorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
